import React, { useEffect, useState } from 'react';

import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import dayjs, { ensureDayjsLocaleLoaded } from '@jpi-cloud-web-pro/jpi-cloud-shared/utils/dayjs';
import PropTypes from 'prop-types';

import { loadCultureByLanguage } from './cultures';

const Wrapper = ({ selectedLanguage, children }) => {
  const [culture, setCulture] = useState(null);

  useEffect(() => {
    let active = true;

    // dayjs only ships `en`; any other locale has to be imported before `dayjs.locale()` takes
    // effect, and it fails silently otherwise. Doing it here covers every page load — until now
    // it only happened inside `selectLanguage`, so a returning user with a stored language got
    // translated UI but English dates.
    loadCultureByLanguage(selectedLanguage).then(async nextCulture => {
      dayjs.locale(await ensureDayjsLocaleLoaded(nextCulture.momentLocale));

      if (active) {
        setCulture(nextCulture);
      }
    });

    return () => {
      active = false;
    };
  }, [selectedLanguage]);

  if (!culture) {
    return null;
  }

  return (
    <IntlProvider locale={culture.language} key={culture.language} messages={culture.messages}>
      {React.Children.only(children)}
    </IntlProvider>
  );
};

Wrapper.propTypes = {
  selectedLanguage: PropTypes.string,
  children: PropTypes.any,
};

const mapStateToProps = state => {
  return {
    selectedLanguage: state.language.selectedLanguage,
  };
};

export default connect(mapStateToProps)(Wrapper);
